// extracted by mini-css-extract-plugin
module.exports = {"container":"announcement-board_container__1KVIS","inner-container":"announcement-board_inner-container__hRb5Y"};